import React from 'react'
import createClass from 'create-react-class'
import PropTypes from 'prop-types'

const stringOrNode = PropTypes.oneOfType([PropTypes.string, PropTypes.node])

export const modelOption = createClass({
    propTypes: {
        children: PropTypes.node,
        className: PropTypes.string,
        isDisabled: PropTypes.bool,
        isFocused: PropTypes.bool,
        isSelected: PropTypes.bool,
        onFocus: PropTypes.func,
        onSelect: PropTypes.func,
        option: PropTypes.object.isRequired
    },
    handleMouseDown(event) {
        event.preventDefault()
        event.stopPropagation()
        this.props.onSelect(this.props.option, event)
    },
    handleMouseEnter(event) {
        this.props.onFocus(this.props.option, event)
    },
    handleMouseMove(event) {
        if (this.props.isFocused) return
        this.props.onFocus(this.props.option, event)
    },
    render() {
        let style = {
            display: 'flex',
            alignItems: 'center',
            columnGap: '8px'
        }
        return (
            <div
                className={this.props.className}
                onMouseDown={this.handleMouseDown}
                onMouseEnter={this.handleMouseEnter}
                onMouseMove={this.handleMouseMove}
                title={this.props.option.title}
                style={style}
            >
                {/*<div style={{width:'25%', justifyContent:'center', display:'flex'}} dangerouslySetInnerHTML={{__html: this.props.option.image}}></div>*/}
                <div style={{ width: '25%', justifyContent: 'center', display: 'flex', maxHeight: '64px' }}>
                    <img src={this.props.option.image} alt="" style={{ maxWidth: '-webkit-fill-available' }} />
                </div>
                <div>{this.props.children}</div>
            </div>
        )
    }
})
export const modelValue = createClass({
    propTypes: {
        children: PropTypes.node,
        placeholder: stringOrNode,
        value: PropTypes.object
    },
    render() {
        let style = {
            display: 'flex',
            height: '100%',
            columnGap: '8px'
        }
        return (
            <div className="Select-value" title={this.props.value.title} style={{ padding: '4px 10px' }}>
                <div className="Select-value-label" style={style}>
                    <img src={this.props.value.image} alt="" />
                    {/*<div dangerouslySetInnerHTML={{__html: this.props.value.image}}/>*/}
                    {this.props.value.label}
                </div>
            </div>
        )
    }
})
